import React from "react";
import Layout from "../../components/Layout/Layout";
import { useState } from "react";
import { useEffect } from "react";
import fire from "./../../utils/Toastr";
import { HollowDotsSpinner } from "react-epic-spinners";
import PreOnboardServices from "../../services/PreObnoard";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import BackButton from "../../components/BackButton";
import Modal from "../../components/Modals/preonboard/modal";

export default function CreateUser() {
  const [accountNo, setAccountNo] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUsername] = useState("");
  const [nin, setNin] = useState("");
  const [lga, setLga] = useState("");
  const [status, setStatus] = useState("");
  const [AccountNoExist, setAccountNoExist] = useState(false);
  const [isFremium, setIsFremium] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const nav = useNavigate();

  const handleCheckboxChange = (e) => {
    setIsFremium(e.target.checked);
  };

  const findUser = async () => {
    if (/^[1-9][0-9]*$/.test(accountNo)) {
      setErrorMessage("Enter a valid account No");
    } else if (accountNo.length <= 0) {
      setErrorMessage("Field cannot be empty");
    } else {
      const res = await PreOnboardServices.getAccount(accountNo);
      setData(res.data);
      setErrorMessage("");
      setAccountNoExist(true);
    }
  };

  useEffect(() => {
    if (data && data.customerName) {
      // Normalize the customer name by trimming and replacing multiple spaces with a single space
      const normalizedName = data.customerName.trim().replace(/\s+/g, " ");
      const fullname = normalizedName.split(" ");
      
      if (fullname.length >= 2) {
        setFirstName(fullname[0]);
        setLastName(fullname.slice(1).join(" ")); // Handle multiple parts of the last name
      } else if (fullname.length === 1) {
        setFirstName(fullname[0]);
        setLastName(""); // Set last name to empty if not provided
      } else {
        setFirstName("");
        setLastName("");
      }
    } else {
      setFirstName("");
      setLastName("");
    }
    
  }, [data]);

  const user = {
    accountNumber: accountNo,
    firstName: firstName,
    surname: lastName,
    emailAddress: data.email,
    userName: userName,
    phoneNumber: data.phoneNumber,
    bvn: data.bvnNumber,
    dateOfBirth: data.dateOfBirth,
    residentialAddress: data.address,
    lga: lga,
    state: data.location,
    title: data.prefix,
    gender: data.gender === "Male" ? "Male" : "Female",
    maritalStatus: status,
    nationalIdentificationNumber: nin,
    isFreemium: isFremium,
  };

  const openModal = () => {
    setOpen(true);
  };
  const submitForm = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      setLoading(true);
      const res = await PreOnboardServices.preOnboardUser(user);
      if (res.status) {

        fire("success", firstName + "," + " onboarded succesfully");
        setAccountNoExist(false);
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        setLoading(false);
        setOpen(false);
        nav("/preonboard");
      } else {
        fire("error", `Failed to preOnboard ${firstName}`);
        setOpen(false);
      }
    } catch (error) {
      setLoading(false);
      setOpen(false);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Layout
        title="PreOnboard User"
        pageTag={"admin"}
        current={"/create/preonboard"}
      >
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto">
              <BackButton />
              <div className="px-4 sm:px-6 lg:px-8">
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                      <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                        <div className="">
                          <div className="block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <form className="px-6">
                              <div className="mt-6 mb-12 flex items-center justify-between">
                                <div className="">
                                  <label
                                    htmlFor="firstname"
                                    className="ml-1 block text-sm font-medium text-gray-700"
                                  >
                                    Account Number
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="accountNo"
                                      onChange={(e) =>
                                        setAccountNo(e.target.value)
                                      }
                                      value={accountNo}
                                      id="accountNo"
                                      autocomplete="given-name"
                                      placeholder="Enter Account Number"
                                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                    <p className="text-sm text-rose-800">
                                      {errMessage}
                                    </p>
                                  </div>
                                </div>
                                <div className="flex gap-2 items-center">
                                  <button
                                    type="button"
                                    onClick={
                                      AccountNoExist ? openModal : findUser
                                    }
                                    className="btn-primary inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                  >
                                    {loading ? (
                                      <HollowDotsSpinner />
                                    ) : (
                                      <>
                                        {" "}
                                        {AccountNoExist
                                          ? "Save User"
                                          : "Find User"}
                                      </>
                                    )}
                                  </button>
                                  {AccountNoExist && (
                                    <button
                                      type="button"
                                      onClick={() => setAccountNoExist(false)}
                                      className="btn-primary inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                    >
                                      Reset
                                    </button>
                                  )}
                                </div>
                              </div>
                              {AccountNoExist && (
                                <React.Fragment>
                                  <div className=" mt-5">
                                    <div className="d-flex flex-col">
                                      <h3>Personal Information</h3>
                                      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-12">
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Prefix
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="prefix"
                                              value={data.prefix}
                                              id="prefix"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p className="text-sm text-rose-800">
                                              {errMessage}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            First Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={firstName}
                                              id="firstnmae"
                                              autocomplete="given-name"
                                              placeholder="Enter your First Name"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p className="text-sm text-rose-800">
                                              {errMessage}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Last Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={lastName}
                                              id="firstnmae"
                                              autocomplete="given-name"
                                              placeholder="Enter your First Name"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p className="text-sm text-rose-800">
                                              {errMessage}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            National Identification Number (NIN)
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              value={nin}
                                              onChange={(e) =>
                                                setNin(e.target.value)
                                              }
                                              name="NIN"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="email"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Email
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="email"
                                              id="email"
                                              placeholder="Enter user's last name"
                                              value={data.email}
                                              autocomplete="given-name"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p className="text-sm text-rose-800">
                                              {errMessage}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="email"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Phone Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="email"
                                              value={data.phoneNumber}
                                              name="email"
                                              placeholder="Enter user's Phone Number"
                                              id="email"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p className="text-sm text-rose-800">
                                              {errMessage}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="username"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Address
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="username"
                                              id="username"
                                              placeholder="Enter user's username"
                                              value={data.address}
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p className="text-sm text-rose-800">
                                              {errMessage}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Location
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.location}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        {/* <div className="">
                                                                        <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                                                            LGA
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input
                                                                            disabled
                                                                                type="text"
                                                                                value={lga}
                                                                                onChange={(e) => setLga(e.target.value)}
                                                                                name="region"
                                                                                placeholder="Enter user's LGA"
                                                                                id="region"
                                                                                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />

                                                                        </div>
                                                                    </div> */}
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Nationality
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.nationality}
                                              name="region"
                                              placeholder="Enter user's Nationality"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Country
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.country}
                                              name="region"
                                              placeholder="Enter user's Nationality"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Gender
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                data.gender == "M"
                                                  ? "Male"
                                                  : "Female"
                                              }
                                              name="region"
                                              placeholder="Enter user's Gender"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Date of birth
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={data.dateOfBirth}
                                              id="firstnmae"
                                              autocomplete="given-name"
                                              placeholder="Enter user's date of birth"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p className="text-sm text-rose-800">
                                              {errMessage}
                                            </p>
                                          </div>
                                        </div>
                                        {/* <div className="">
                                                                        <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                                                            Marital status
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input
                                                                            disabled
                                                                                type="text"
                                                                                value={status}
                                                                                onChange={(e) => setStatus(e.target.value)}
                                                                                name="region"
                                                                                placeholder="Enter user's Marital status"
                                                                                id="region"
                                                                                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />

                                                                        </div>
                                                                    </div> */}
                                      </div>
                                    </div>
                                    <div className="d-flex flex-col mt-12">
                                      <h3>Account Imformation</h3>
                                      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-12">
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Customer Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.customerNo}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Customer Type
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.customerType}
                                              onChange={(e) =>
                                                setUsername(e.target.value)
                                              }
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Account Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.accountNumber}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Alternative Account Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.altAcNo}
                                              onChange={(e) =>
                                                setUsername(e.target.value)
                                              }
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            BVN
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.bvnNumber}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Account Type
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.accountType}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Account Class
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                data.accountClassDescription
                                              }
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Alternative Class Code
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.accountClassCode}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Customer Category
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.customerCategory}
                                              name="region"
                                              placeholder="Enter user's Nationality"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Branch Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.branchName}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Available Balance
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.availableBalance}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Blocked Amount
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.blockedAmount}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Book Balance
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.bookBalance}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Currency Code
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.ccyCode}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Currency
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.ccyName}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>

                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Default Media
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.defaultMedia}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Introducer MISCODE
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.introducerMis}
                                              name="region"
                                              placeholder="Enter user's introducer's mis"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Joint Account Indicator
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.jointAcIndicator}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Mandate Authority
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.mandateAuthority}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Minor
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                data.minor ? "True" : "False"
                                              }
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Relationship Manager's Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                data.relationshipManagerName
                                              }
                                              name="region"
                                              placeholder="Enter user's relationship manager's name"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Relationship Manager's Code
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                data.relationshipManagerCode
                                              }
                                              name="region"
                                              placeholder="Enter user's relationship manager's code"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Signatories
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={data.signatory}
                                              name="region"
                                              placeholder="Enter user's signatory"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="flex items-center gap-2 mt-5">
                                          <label className="shadow-sm border-[1px] focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md py-2 px-2 text-gray-600">
                                            Interested in the fremium model?
                                          </label>
                                          <input
                                            type="checkbox"
                                            checked={isFremium}
                                            onChange={handleCheckboxChange}
                                            className="appearance-none checked:bg-red-500 w-8 h-8 rounded-md"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {open && (
                <Modal
                  textField="You want to onboard this user"
                  status={"preonboarding"}
                  action={submitForm}
                  setOpen={setOpen}
                  open={open}
                />
              )}
            </div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
